/* eslint-disable react-hooks/exhaustive-deps */
// this code is copied from `react-use`, but modified to throw an error on error so a try{}catch{} will actually catch it
import { useCallback, useRef, useState, useEffect } from 'react';
import { useDebounce } from 'react-use';

export function useMountedState() {
  const mountedRef = useRef(false);
  const get = useCallback(() => mountedRef.current, []);
  useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
    };
  });
  return get;
}

export function useAsyncFn(fn, deps = [], initialState) {
  initialState = { ...{ loading: false }, ...initialState };
  const lastCallId = useRef(0);
  const isMounted = useMountedState();
  const [state, set] = useState(initialState);
  const callback = useCallback(async (...args) => {
    const callId = ++lastCallId.current;
    set(prevState => Object.assign(Object.assign({}, prevState), { loading: true }));
    try {
      const value = await fn(...args);
      isMounted() && callId === lastCallId.current && set({ value, loading: false });
      return value;
    } catch (err) {
      isMounted() && callId === lastCallId.current && set({ error: err, loading: false });
      throw err;
    }
  }, deps);
  return [state, callback];
}

export function useDebouncedValue(value, delay = 350) {
  const [debouncedValue, setDebouncedValue] = useState(value);
  useDebounce(() => setDebouncedValue(value), delay, [value, setDebouncedValue]);
  return debouncedValue;
}

export function useDebouncedValueNext(initialValue, delay = 350) {
  const [value, setValue] = useState(initialValue);
  const [debouncedValue, setDebouncedValue] = useState(value);
  useDebounce(() => setDebouncedValue(value), delay, [value, setDebouncedValue]);
  return {
    value,
    setValue,
    debouncedValue,
  };
}
